export default
`
2019-present: MRC-funded Skills Development Fellow, University of Exeter/University of Birmingham, UK.\r\n
2019-2021: Visiting scientist, University of Cambridge, UK. \r\n
2017-2022: Visiting scientist, University of Michigan, USA. \r\n
2017-2018: Secondee to learn bioinformatics, University of Exeter, UK. \r\n
2012-2014: Student dietitian. Alder Hay Children’s Hospital, Blackpool Teaching Hospital, Royal Liverpool University Hospital.\r\n
`


// WEBPACK FOOTER //
// ./src/content/career.js